// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isUploadCsvChunkResult = objectOf({
  name: string,
  id: string,
  detected_header: arrayOf(
    objectOf({
      is_custom: boolean,
      name: string,
      data_type: string,
    })
  ),
  detected_rows: arrayOf(arrayOf(string)),
  warnings: arrayOf(string),
  can_import: boolean,
  segment_warnings: arrayOf(string),
});
